<template>
  <div class="card-container">
    <base-card v-for="type in mealType" :key="type.name" :cardContent="type" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      mealType: [
        { name: "Starters", path: "starters" },
        { name: "Main Course", path: "main-course" },
        {
          name: "Sweets and Drinks",
          path: "sweets-and-drinks",
        },
      ],
    };
  },
};
</script>
